import { Form, Input, Row, Tooltip } from "antd";
import { Rule } from "antd/es/form";
import { ReactNode, useMemo } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { CommentTooltip } from "./CommentTooltip";

const { TextArea } = Input;

type CommentProps = {
  data: any;
};

export const Comment = ({ data }: CommentProps) => {
  const rules: Rule[] = useMemo(
    () => [
      {
        required: true,
        validateTrigger: "onSubmit",
      },
      {
        max: 500,
        message: "Comment shouldn't contain more than 500 characters",
        validateTrigger: "onSubmit",
      },
    ],
    [],
  );

  const label: ReactNode = useMemo(() => {
    const taskName: string = data ? data.name : "";

    return (
      <Row className="align-center">
        <p className="my-0 text-md title">Comment in the email</p>
        <Tooltip
          title={<CommentTooltip name={taskName} />}
          trigger="hover"
          overlayClassName="comment-tooltip"
          placement="right"
        >
          <InfoCircleOutlined className="ml-1" />
        </Tooltip>
      </Row>
    );
  }, [data]);

  return (
    <Form.Item
      name="comment"
      label={label}
      className="mb-5 mt-4 pr-6"
      rules={rules}
    >
      <TextArea
        rows={2}
        placeholder="e.g., all changes to the account have been entered."
      />
    </Form.Item>
  );
};
